import React from 'react';
import Toggler from "../../../elements/Toggler";
import SelectNested from "../../../elements/SelectNested";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import QNestedDatePicker from "../../../elements/QNestedDatePicker";
import EmployeeTrainingDocuments from "./EmployeeTrainingDocuments";

const DateField = ({label, training, index, state, field}) => (
  <div className="col-md-2">
    <label className="form-label small">{label}</label>
    <QNestedDatePicker
      pickerId={`${field}-${training.id}`}
      errorParagraphId={`${field}-error-${training.id}`}
      state={state}
      property="employeeTrainings"
      propertyPath={`employeeTrainings[${index}].${field}`}
      startDate={training[field] ? new Date(training[field]) : null}
      isDisabled={false}
    />
  </div>
);

const EmployeeTraining = ({training, index, state, onInputChange, trainingsList, supervisorsList, onRemove, settings}) => (
  <div className="border rounded p-2 mb-2 bg-light-subtle">
    <div className="row g-2 align-items-end">
      <div className="col-md-3">
        <label className="form-label small">Typ szkolenia</label>
        <SelectNested propertyName={`employeeTrainings[${index}].training`} state={state} itemsList={trainingsList} displayNames={["name"]} showInput={false} showDelete={false} useId={false}/>
      </div>
      <div className="col-md-3">
        <label className="form-label small">Osoba prowadząca</label>
        <SelectNested propertyName={`employeeTrainings[${index}].trainerID`} state={state} itemsList={supervisorsList} displayNames={["firstName", "lastName"]} showInput={false} showDelete={false} useId={true}/>
      </div>
      <DateField label="Przypisano" training={training} index={index} state={state} field="assignedDate"/>
      <DateField label="Początek" training={training} index={index} state={state} field="dateFrom"/>
      <DateField label="Koniec" training={training} index={index} state={state} field="dateTo"/>
      <div className="col-md-1 text-end">
        <button type="button" className="btn btn-outline-danger" onClick={onRemove}><FontAwesomeIcon icon={faTrashAlt}/></button>
      </div>
    </div>

    <div className="row g-2 align-items-end mt-1">
      <div className="col-md-2">
        <label className="form-label small">Ocena punktowa</label>
        <input type="number" className="form-control" value={training.evaluation ?? ""} min={settings.trainingEvaluationMinimumValue} max={settings.trainingEvaluationMaximumValue} step="0.01" onChange={e => onInputChange(e, training, "evaluation")}/>
      </div>
      <DateField label="Data oceny" training={training} index={index} state={state} field="evaluationDate"/>
      <div className="col-md-3">
        <label className="form-label small">Osoba wystawiająca ocenę</label>
        <SelectNested propertyName={`employeeTrainings[${index}].evaluationById`} state={state} itemsList={supervisorsList} displayNames={["firstName", "lastName"]} showInput={false} showDelete={false} useId={true}/>
      </div>
      <div className="col-md-5">
        <label className="form-label small">Ocena opisowa</label>
        <input type="text" className="form-control" value={training.evaluationDescription || ""} onChange={e => onInputChange(e, training, "evaluationDescription")} placeholder="Opis umiejętności, postępów i obszarów do poprawy"/>
      </div>
    </div>

    <div className="row g-2 align-items-end mt-1">
      <div className="col-md-2">
        <label className="form-label small">Koszt szkolenia</label>
        <input type="number" min="0" step="0.01" className="form-control" value={training.cost ?? ""} onChange={e => onInputChange(e, training, "cost")}/>
      </div>
      <DateField label="Termin testu" training={training} index={index} state={state} field="testDueDate"/>
      <div className="col-md-2">
        <label className="form-label small d-block">Ukończone</label>
        <Toggler propertyName={`employeeTrainings[${index}].completed`} state={state}/>
      </div>
      <div className="col-md-6">
        <label className="form-label small">Uwagi organizacyjne</label>
        <input type="text" className="form-control" value={training.comments || ""} onChange={e => onInputChange(e, training, "comments")}/>
      </div>
    </div>

    <div className="row g-2 align-items-end mt-1">
      <DateField label="Weryfikacja umiejętności do" training={training} index={index} state={state} field="verificationDueDate"/>
      <div className="col-md-2">
        <label className="form-label small d-block">Weryfikacja wykonana</label>
        <Toggler propertyName={`employeeTrainings[${index}].verificationCompleted`} state={state}/>
      </div>
      <DateField label="Data weryfikacji" training={training} index={index} state={state} field="verificationDate"/>
      <div className="col-md-6 small text-muted pb-2">Jeżeli szkolenie jest ukończone, a termin weryfikacji nie został podany, system ustawi go automatycznie miesiąc po zakończeniu szkolenia i przypomni osobie prowadzącej przed terminem.</div>
    </div>

    <EmployeeTrainingDocuments employeeTrainingId={training.id}/>
  </div>
);

export default EmployeeTraining;
